import { useTranslation } from 'react-i18next'
import { ConfigurationHeaderWrapper } from '../../../../_components/configuration-header-wrapper.component'
import { ErrorQueryHandler } from 'src/components/error/error-query-handler.component'
import { getTranslatedLabel } from 'src/utils/locale.util'
import { FollowupTimeline } from '../../_components/followup-timeline.component'
import { useLocalizedNavigate } from 'src/hooks/use-localized-navigate'
import { ChatbotGeneralForm } from '../_components/chatbot-general-form/chatbot-general-form.component'
import { useState } from 'react'
import { useSortedFollowupTimeline } from '../../_components/use-sorted-followup-timeline.hook'
import { useParams } from 'react-router-dom'
import { useLocale } from 'src/hooks/use-locale'

export default function ConfigurationFollowupsFollowupIdAddChatbotPage() {
  const { t } = useTranslation()
  const navigate = useLocalizedNavigate()
  const { followupId } = useParams()
  const { locale } = useLocale()
  const [agentName, setAgentName] = useState<string>(
    t('pages.configuration.followups.chatbot.general-form.creating-agent'),
  )
  const { isLoading, error, followupTimeline, timelineMedEventsSorted } = useSortedFollowupTimeline(
    followupId as string,
  )

  if (error) return <ErrorQueryHandler error={error} />
  if (isLoading || !followupTimeline) return <div className="loading" />

  return (
    <ConfigurationHeaderWrapper
      title={t('pages.configuration.followups.manage-followup', {
        followupName: getTranslatedLabel(locale, followupTimeline.intlName),
      })}
      subTitle={t('pages.configuration.followups.description')}
      className="c-flex c-flex-row c-pb-10 c-relative"
    >
      <FollowupTimeline timelineMedEventsSorted={timelineMedEventsSorted} itemLabelBeingAdded={agentName} />
      <div className="c-bg-grey-200 c-w-px c-h-full" />
      <div className="c-w-full c-pl-4">
        <h2 className="c-text-xl c-font-bold c-mb-2">
          {t('pages.configuration.followups.chatbot.general-form.step-title')}
        </h2>
        <p className="c-text-sm c-text-gray-600 c-mb-6">
          {t('pages.configuration.followups.chatbot.general-form.step-subtitle')}
        </p>
        <ChatbotGeneralForm onCancel={() => navigate(-1)} onNameChange={setAgentName} />
      </div>
    </ConfigurationHeaderWrapper>
  )
}
